angular.module('elfium').directive('businessCaseListItemDetail', ['$compile', 'elfiumUrlService', function ($compile, elfiumUrlService) {
    return {
        restrict: 'A',
        scope: false,
        controller: 'businessCaseListItemDetailController',
        link: function (scope, element, attrs) {
            scope.templateUrl = elfiumUrlService.getTemplateUrl('businessCase', 'businessCaseListItemDetail');
            var contentTr = angular.element('<tr ng-if="shouldShow" ng-include="templateUrl"></tr>');
            contentTr.insertAfter(element);
            $compile(contentTr)(scope);

            scope.$watch(function (scope) {
                return scope.$eval(attrs.businessCaseListItemDetailShow);
            }, function (value) {
                scope.shouldShow = value;
            });
            scope.$watch(function (scope) {
                return scope.$eval(attrs.businessCaseListItemDetail);
            }, function (value) {
                scope.businessCaseListItem = value;
            });
        }
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/businessCase/businessCaseListItemDetail.ts